
import { Database, Wrench, TestTube, Sigma, BarChart2 } from 'lucide-react';
import { WorkflowNode, WorkflowEdge } from './types';
import { MarkerType } from '@xyflow/react';

// Initial nodes for the workflow
export const initialNodes: WorkflowNode[] = [
  {
    id: '1',
    type: 'custom',
    position: { x: 50, y: 100 },
    data: {
      label: 'Data Ingestion',
      icon: <Database className="h-5 w-5 text-blue-500" />,
      description: 'Connect to databases or load CSV files to import your data'
    }
  },
  {
    id: '2',
    type: 'custom',
    position: { x: 350, y: 100 },
    data: {
      label: 'Data Wrangling',
      icon: <Wrench className="h-5 w-5 text-orange-500" />,
      description: 'Clean, transform, and prepare your data for analysis'
    }
  },
  {
    id: '3',
    type: 'custom',
    position: { x: 650, y: 100 },
    data: {
      label: 'Experiment Preparation',
      icon: <TestTube className="h-5 w-5 text-purple-500" />,
      description: 'Configure your A/B test parameters and set up experiment design'
    }
  },
  {
    id: '4',
    type: 'custom',
    position: { x: 950, y: 100 },
    data: {
      label: 'Analysis Engine',
      icon: <Sigma className="h-5 w-5 text-primary" />,
      description: 'Apply statistical models to analyze your data with credible intervals'
    }
  },
  {
    id: '5',
    type: 'custom',
    position: { x: 1250, y: 100 },
    data: {
      label: 'Visualization',
      icon: <BarChart2 className="h-5 w-5 text-green-500" />,
      description: 'View results and generate reports with interactive visualizations'
    }
  }
];

// Initial edges connecting the nodes
export const initialEdges: WorkflowEdge[] = [
  { 
    id: 'e1-2', 
    source: '1', 
    target: '2', 
    sourceHandle: 'output',
    targetHandle: 'input',
    animated: true,
    style: { stroke: '#3B82F6' },
    markerEnd: {
      type: MarkerType.ArrowClosed,
      width: 15,
      height: 15,
      color: '#3B82F6',
    },
  },
  { 
    id: 'e2-3', 
    source: '2', 
    target: '3', 
    sourceHandle: 'output',
    targetHandle: 'input',
    animated: true,
    style: { stroke: '#3B82F6' },
    markerEnd: {
      type: MarkerType.ArrowClosed,
      width: 15,
      height: 15,
      color: '#3B82F6',
    },
  },
  { 
    id: 'e3-4', 
    source: '3', 
    target: '4', 
    sourceHandle: 'output',
    targetHandle: 'input',
    animated: true,
    style: { stroke: '#3B82F6' },
    markerEnd: {
      type: MarkerType.ArrowClosed,
      width: 15,
      height: 15,
      color: '#3B82F6',
    },
  },
  { 
    id: 'e4-5', 
    source: '4', 
    target: '5', 
    sourceHandle: 'output',
    targetHandle: 'input',
    animated: true,
    style: { stroke: '#3B82F6' },
    markerEnd: {
      type: MarkerType.ArrowClosed,
      width: 15,
      height: 15,
      color: '#3B82F6',
    },
  }
];
